import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import {EmployeeTagFilterMixin, HotelFilterMixin, UserFilterMixin} from "./FilterMixin";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import {axiosGet} from "../../../common/Helper/AxiosHelper";
import {convertSecondToHourMinutes} from "../../../common/Helper/Support/DateTimeHelper";
import moment from "moment";

export default {
    mixins: [HelperMixin, DatatableHelperMixin, UserFilterMixin, HotelFilterMixin, EmployeeTagFilterMixin],
    data() {
        return {
            options: {
                name             : this.$t('commission_details'),
                url              : `${TENANT_BASE_URL}app/commission`,
                preserveState    : true,
                showHeader       : true,
                enableRowSelect  : true,
                tableShadow      : false,
                tablePaddingClass: 'pt-primary',
                columns          : [
                    {
                        title    : 'MM/YYYY',
                        type     : 'custom-html',
                        key      : 'month',
                        isVisible: true,
                        modifier : (month, row) => month + '/' + row.year
                    },
                    {
                        title    : this.$t('hotel'),
                        type     : 'custom-html',
                        key      : 'hotel',
                        isVisible: true,
                        modifier : (value) => value.name
                    },
                    {
                        title    : this.$t('employee_name'),
                        type     : 'custom-html',
                        key      : 'user',
                        isVisible: true,
                        modifier : (value) => {
                            const employeeId = value && value.profile ? value.profile.employee_id : '';
                            return employeeId ? `${value.full_name} (${employeeId})` : value.full_name;
                        }
                    },
                    {
                        title    : this.$t('housekeeping_fee'),
                        type     : 'custom-html',
                        key      : 'housekeeping_fee',
                        isVisible: true,
                        modifier : (value, row) => row.housekeeping_confirmed + ' (' + value + ')'
                    },
                    {
                        title    : this.$t('commute_fee'),
                        type     : 'custom-html',
                        key      : 'commute_fee',
                        isVisible: true,
                        modifier : (value, row) => row.commute_confirmed + ' (' + value + ')'
                    },
                    {
                        title    : this.$t('total_hours'),
                        type     : 'custom-html',
                        key      : 'total_hours',
                        isVisible: true,
                        modifier : (value) => convertSecondToHourMinutes(value || 0)
                    },
                    {
                        title        : this.$t('remark'),
                        type         : 'component',
                        key          : 'remark',
                        isVisible    : true,
                        componentName: 'app-commission-remark',
                    },
                ],
                filters          : [
                    {
                        title         : this.$t('hotel'),
                        type          : "multi-select-filter",
                        key           : "hotels",
                        option        : [],
                        listValueField: 'name',
                        permission    : !!this.$can('view_hotel_list')
                    },
                    {
                        title         : this.$t('users'),
                        type          : "multi-select-filter",
                        key           : "users",
                        option        : [],
                        listValueField: 'employee_name',
                        permission    : !!this.$can('view_users')
                    },
                    {
                        title         : this.$t('month'),
                        type          : "month-filter",
                        key           : "month",
                        initValue     : moment().format('YYYY-MM'),
                    },
                    {
                        title         : this.$t('employee_tags'),
                        type          : "multi-select-filter",
                        key           : "employee_tags",
                        option        : [],
                        listValueField: 'name',
                    },
                ],
                paginationOptions: [10, 40, 60, 80, 100, 200],
                paginationType   : "pagination",
                responsive       : true,
                rowLimit         : 0,
                showAction       : false,
                orderBy          : 'desc',
                actionType       : 'default',
                actions          : [],
            }
        }
    },
    mounted() {
        this.hydrateDependentFiltersFromUrl();
        window.addEventListener('popstate', this.hydrateDependentFiltersFromUrl);
    },
    beforeDestroy() {
        window.removeEventListener('popstate', this.hydrateDependentFiltersFromUrl);
    },
    methods: {
        hydrateDependentFiltersFromUrl() {
            const query = new URLSearchParams(window.location.search);

            this.getUsers({
                month: query.get('month') || this.options.filters.find(fl => fl.key === 'month')?.initValue
            });
        },
        getTerminateDateFrom(value = {}) {
            const selectedMonth = value.month || this.options.filters.find(fl => fl.key === 'month')?.initValue;

            if (!selectedMonth) {
                return '';
            }

            return moment(`${selectedMonth}-01`).format('YYYY-MM-DD');
        },
        getUsers(value = {}) {
            const terminateDateFrom = this.getTerminateDateFrom(value);
            const terminateDateQuery = terminateDateFrom ? `?terminate_date_from=${encodeURIComponent(terminateDateFrom)}` : '';

            axiosGet(`${this.apiUrl.TENANT_SELECTABLE_USER}${terminateDateQuery}`).then(({data}) => {
                this.options.filters.find(fl => fl.key === 'users' && fl.type === 'multi-select-filter').option = data;
            })
        },
        getFilterValues(value) {
            this.getUsers(value);
        }
    }
}
